import type * as Types from '../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetJobsForAdminListingQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetJobsForAdminListingQuery = { admin: { jobs: Array<{ id: number, title: string, details: string | null, created: string, type: Types.JobAdminType, status: Types.JobStatusEnum | null, killable: boolean, owner: { firstName: string | null, lastName: string | null, username: string | null } } | null> | null } | null };

export type JobAdminListingFragment = { id: number, title: string, details: string | null, created: string, type: Types.JobAdminType, status: Types.JobStatusEnum | null, killable: boolean, owner: { firstName: string | null, lastName: string | null, username: string | null } };

export type StopWorkflowsMutationVariables = Types.Exact<{
  workflowEventIds: Array<Types.InputMaybe<Types.Scalars['Long']['input']>> | Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type StopWorkflowsMutation = { workflow: { stopWorkflows: boolean } };

export const JobAdminListingFragmentDoc = gql`
    fragment JobAdminListing on JobAdmin {
  id
  title
  details
  created
  type
  status
  killable
  owner {
    firstName
    lastName
    username
  }
}
    `;
export const GetJobsForAdminListingDocument = gql`
    query getJobsForAdminListing {
  admin {
    jobs {
      ...JobAdminListing
    }
  }
}
    ${JobAdminListingFragmentDoc}`;

/**
 * __useGetJobsForAdminListingQuery__
 *
 * To run a query within a React component, call `useGetJobsForAdminListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsForAdminListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsForAdminListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobsForAdminListingQuery(baseOptions?: Apollo.QueryHookOptions<GetJobsForAdminListingQuery, GetJobsForAdminListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobsForAdminListingQuery, GetJobsForAdminListingQueryVariables>(GetJobsForAdminListingDocument, options);
      }
export function useGetJobsForAdminListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsForAdminListingQuery, GetJobsForAdminListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobsForAdminListingQuery, GetJobsForAdminListingQueryVariables>(GetJobsForAdminListingDocument, options);
        }
export function useGetJobsForAdminListingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobsForAdminListingQuery, GetJobsForAdminListingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobsForAdminListingQuery, GetJobsForAdminListingQueryVariables>(GetJobsForAdminListingDocument, options);
        }
export type GetJobsForAdminListingQueryHookResult = ReturnType<typeof useGetJobsForAdminListingQuery>;
export type GetJobsForAdminListingLazyQueryHookResult = ReturnType<typeof useGetJobsForAdminListingLazyQuery>;
export type GetJobsForAdminListingSuspenseQueryHookResult = ReturnType<typeof useGetJobsForAdminListingSuspenseQuery>;
export type GetJobsForAdminListingQueryResult = Apollo.QueryResult<GetJobsForAdminListingQuery, GetJobsForAdminListingQueryVariables>;
export const StopWorkflowsDocument = gql`
    mutation stopWorkflows($workflowEventIds: [Long]!) {
  workflow {
    stopWorkflows(eventIds: $workflowEventIds)
  }
}
    `;
export type StopWorkflowsMutationFn = Apollo.MutationFunction<StopWorkflowsMutation, StopWorkflowsMutationVariables>;

/**
 * __useStopWorkflowsMutation__
 *
 * To run a mutation, you first call `useStopWorkflowsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopWorkflowsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopWorkflowsMutation, { data, loading, error }] = useStopWorkflowsMutation({
 *   variables: {
 *      workflowEventIds: // value for 'workflowEventIds'
 *   },
 * });
 */
export function useStopWorkflowsMutation(baseOptions?: Apollo.MutationHookOptions<StopWorkflowsMutation, StopWorkflowsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopWorkflowsMutation, StopWorkflowsMutationVariables>(StopWorkflowsDocument, options);
      }
export type StopWorkflowsMutationHookResult = ReturnType<typeof useStopWorkflowsMutation>;
export type StopWorkflowsMutationResult = Apollo.MutationResult<StopWorkflowsMutation>;
export type StopWorkflowsMutationOptions = Apollo.BaseMutationOptions<StopWorkflowsMutation, StopWorkflowsMutationVariables>;